import React from "react";
import { IT } from "../data/siteData";
import ServicePage from "./ServicePage";

export default function ITPage({ onNavigate }) {
  return (
    <ServicePage hero={IT.hero} onNavigate={onNavigate}>
      <section className="section">
        <div className="capability-grid">
          {IT.offerings.map((o, i) => (
            <div key={i} className="capability-card">
              <div className="capability-card-header">
                <h4>{o.title}</h4>
                <span className="capability-icon">{o.icon}</span>
              </div>
              <p>{o.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </ServicePage>
  );
}
